module.exports = __webpack_public_path__ + "05_bob_black.df5e7e0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/05_bob_black.png
// module id = kMHu
// module chunks = 0